<template>
  <dd-validation-rules-wrapper :name="name" :rules="rules">
    <template #default="validationWrapperProps">
      <validation-provider ref="provider" :name="name" :rules="validationWrapperProps.rules" v-slot="validationProps">
        <dd-input-wrapper
            :rules="validationWrapperProps.rules"
            :title="title"
            :errors="validationProps.errors"
            :name="name"
            :value="value"
            :provider-ref="$refs.provider"
            v-slot="{validateInput}"
        >
          <a-input-number
              :data-dusk="dataDusk"
              v-bind="$attrs"
              :name="name"
              :value="localModelValue"
              @blur="() => validateInput(value)"
              @change="(newValue) => onChange(newValue)"
              :min="min"
          />
        </dd-input-wrapper>
      </validation-provider>
    </template>
  </dd-validation-rules-wrapper>
</template>

<script>
export default {
  name: "NumberInput.vue",
  emits: ['input', 'house-number'],
  props: {
    dataDusk: String,
    title: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    value: {
      type: [Number, String],
      required: false
    },
    rules: {
      type: [String, Array, Object],
      required: false,
    },
    min:{
      type: Number,
      required: false,
    }
  },
  data() {
    return {
      localModelValue: this.value,
    }
  },
  watch: {
    value() {
      this.localModelValue = this.value;
    }
  },
  methods: {
    onChange(value) {
      this.localModelValue = value;
      this.$emit('input', this.localModelValue);
      if (this.title === 'Huisnummer') {
        this.$emit('house-number', this.localModelValue);
      }
    },
  }
};
</script>

<style lang="scss" >
@import "~@/_default.scss";
.form-input {
  .ant-input-number {
    overflow: clip;
    height: auto;
    border-radius: $border-radius-base;
    color: $text-color;
    border: 1px solid rgba($brand-primary, 0.25);
    font-size: $font-size-small;
    width: 100%;
    background-color: rgba($main-content-bg-color, 0.5);
    .ant-input-number-input-wrap > input {
      height: auto;
      padding: $spacing-xs $spacing-sm;
    }
  }
}

</style>
